import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useLazyQuery } from 'react-apollo'
import qs from 'query-string'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { MODALS, SIGN_UP_SCREENS } from '../../../constants'
import { REGEX } from '../../../utils/regex'
import { STORAGE_KEY_EMAIL_ON_GUEST_HOME_PAGE } from '../../../storage-keys'
import Input from '../../forms/input'
import Button from '../../button'
import CEHCK_EMAIL_QUERY from '../../../../graphql/queries/check-email.gql'
import { useStyles } from './emailBox.styles'

/*
* EmailBox component handles user input for email validation. It validates the email format,
* shows error messages, and navigates the user to either the login modal or the sign-up form
* based on the result of the email validation query.
* This component will be used on hotspot slide and callForAcition component on logged out home page.
*/

const EmailBox = ({ buttonText, inputText, isTVOD }) => {
  const styles = useStyles()
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const [validateEmail, { loading, error, data }] = useLazyQuery(CEHCK_EMAIL_QUERY, {
    fetchPolicy: 'no-cache'
  })

  useEffect(() => {
    if (error) {
      setEmailError('An unexpected error occurred. Please try again later.')
    }
  }, [error])

  useEffect(() => {
    // Save email in local storage
    if (email) {
      sessionStorage.setItem(STORAGE_KEY_EMAIL_ON_GUEST_HOME_PAGE, email)
    }

    if (data) {
      const checkEmailResult = data.checkEmail
      if (checkEmailResult) {
        // Nav to login modal
        history.replace({
          ...location,
          search: qs.stringify({
            modal: MODALS.qsParams.login
          })
        })
      } else {
        // Nav to sign up form
        history.replace({
          pathname: SIGN_UP_SCREENS.SIGN_UP.path,
          search: null
        })
      }
    }

    // Clear input email
    setEmail('')
    setEmailError('')
  }, [data])

  const handleChange = (e) => {
    setEmail(e.target.value)
  }

  const handleSubmit = () => {
    const REGES_EMAIL = new RegExp(REGEX.email)
    if (!email) {
      setEmailError('Email is required')
    } else if (!REGES_EMAIL.test(email)) {
      setEmailError('Invalid email address')
    } else {
      validateEmail({ variables: { email } })
    }
  }

  return (
    <div className={styles.emailBoxFrame}>
      <Input
        type="email"
        name="email"
        placeholder={inputText}
        inputClass={styles.emailInput}
        value={email}
        onChange={handleChange}
        onBlur={() => {}}
        warning={emailError}
        warningClass={styles.errorMessage}
        exclamationClass={styles.exclamation}
        data-e2e="validate-email"
      />
      <Button
        wrapperClassName={styles.buttonWrapper}
        text={buttonText}
        className={classnames(styles.checkEmailButton, isTVOD && styles.tvodButton)}
        onClick={handleSubmit}
        disabled={loading}
      />
    </div>
  )
}

EmailBox.propTypes = {
  buttonText: PropTypes.string.isRequired,
  inputText: PropTypes.string.isRequired,
  isTVOD: PropTypes.bool.isRequired
}

export default EmailBox
